module.exports = __webpack_public_path__ + "static/gubretas3-b1f3f27bd9af1528ac20d228da10659f.png";